export function isMobileDevice() {
    if (typeof navigator === "undefined") return false;

    const ua = navigator.userAgent || navigator.vendor || window.opera || "";

    // Covers common phone/tablet UAs (iOS, Android, Windows Phone,
    // BlackBerry, Opera Mini, etc). Deliberately does NOT match
    // desktop Chrome/Firefox/Safari/Edge on Windows/macOS/Linux.
    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini|windows phone|mobile/i.test(
        ua
    );
}